
<iframe style="width: 100%; height: 75vh;"
[src]="webinar.videoEmbedUrl | safeHtml:'resourceUrl'">
</iframe>
